'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _Eye = require('./Eye');

Object.defineProperty(exports, 'default', {
  enumerable: true,
  get: function get() {
    return _interopRequireDefault(_Eye).default;
  }
});

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }


//////////////////
// WEBPACK FOOTER
// ./~/@bibliocommons/base-icons/lib/components/Eye/index.js
// module id = 1180
// module chunks = 1